import React from 'react'

export default function PostTextArea({ content }) {
  let { body } = content
  body = body?.replace(/<ul>/g, `<ul class="list-primary">`)

  return (
    <section className='textarea'>
      <div className='textarea__container'>
        <div
          className='textarea__text'
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </div>
    </section>
  )
}
